import * as React from "react";
import { Input, Col, Form, Checkbox, Row } from "antd";
import { FormInstance } from "antd/lib/form";
import { IAttachmentType } from "../../model/AttachmentType";
import { IGenericCodebookItem } from "../../../codebooks/model/GenericCodebookItem";
import SelectInput from "../../../core/ui/components/SelectInput";
import { IOrganisation } from "../../../organisations/model/Organisation";

const FormFields = {
  ID: "id",
  ORGANISATION_ID: "organisationId",
  CONTENT_TYPE_ID: "attachmentContentTypeId",
  NAME: "name",
  ANONYMISATION_REQUIRED: "anonymisationRequired",
  VALID: "valid"
};

const AttachmentTypeForm = ({
  translate,
  form,
  rowData,
  contentTypes,
  organisationId,
  organisations
}: {
  translate: any;
  form: FormInstance;
  rowData?: IAttachmentType;
  contentTypes: IGenericCodebookItem[];
  organisationId?: number;
  organisations?: IOrganisation[];
}) => {
  return (
    <Form layout={"vertical"} form={form}>
      <Form.Item
        style={{ display: "none" }}
        name={FormFields.ID}
        initialValue={rowData?.id}
      >
        <Input />
      </Form.Item>

      <Row gutter={16} className={"content-section-modal-emphasize"}>
        <Col lg={22} sm={21} xs={20}>
          <Form.Item
            label={translate("editors.attachment_types.name")}
            className={"mb-0"}
            name={FormFields.NAME}
            initialValue={rowData?.name}
            rules={[
              {
                required: true,
                message: translate(
                  "editors.attachment_types.required_messages",
                  {
                    field: translate("editors.attachment_types.name")
                  }
                )
              }
            ]}
          >
            <Input />
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col
          lg={2}
          sm={3}
          xs={4}
          style={{
            display: "flex",
            marginTop: 20,
            alignItems: "center"
          }}
        >
          <Form.Item
            label={translate("editors.attachment_types.anonymisation_required")}
            name={FormFields.ANONYMISATION_REQUIRED}
            valuePropName={"checked"}
            initialValue={rowData?.anonymisationRequired ?? true}
          >
            <Checkbox />
          </Form.Item>
        </Col>
        <Col
          lg={2}
          sm={3}
          xs={4}
          style={{
            display: "flex",
            marginTop: 20,
            alignItems: "center",
            marginLeft: 40
          }}
        >
          <Form.Item
            label={translate("editors.attachment_types.valid")}
            style={{ marginTop: "1em" }}
            name={FormFields.VALID}
            valuePropName={"checked"}
            initialValue={rowData?.valid ?? true}
          >
            <Checkbox />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16} className={"content-section-modal-borderless pb-0"}>
        <Col xs={24} sm={24}>
          <Form.Item
            label={translate("editors.attachment_types.content_type")}
            className={"mb-0"}
            name={FormFields.CONTENT_TYPE_ID}
            initialValue={rowData?.attachmentContentTypeId}
            rules={[
              {
                required: true,
                message: translate(
                  "editors.attachment_types.required_messages",
                  {
                    field: translate("editors.attachment_types.content_type")
                  }
                )
              }
            ]}
          >
            <SelectInput
              placeholder={translate(
                "editors.attachment_types.select_content_type"
              )}
              allowClear
              showSearch={true}
              notFoundContent={translate("search.no_data")}
              selectOptionKey={"id"}
              selectOptionValue={"value"}
              selectOptions={contentTypes}
            />
          </Form.Item>
        </Col>
      </Row>
      {organisationId ? (
        <Form.Item
          style={{ display: "none" }}
          name={FormFields.ORGANISATION_ID}
          initialValue={rowData?.organisationId ?? organisationId}
        >
          <Input />
        </Form.Item>
      ) : (
        <Row gutter={16} className={"content-section-modal-borderless pb-0"}>
          <Col xs={24} sm={24}>
            <Form.Item
              label={translate("editors.attachment_types.organisation")}
              className={"mb-0"}
              name={FormFields.ORGANISATION_ID}
              initialValue={rowData?.organisationId}
            >
              <SelectInput
                placeholder={translate(
                  "editors.attachment_types.select_organisation"
                )}
                allowClear
                showSearch={true}
                notFoundContent={translate("search.no_data")}
                selectOptionKey={"id"}
                selectOptionValue={"name"}
                selectOptions={organisations}
              />
            </Form.Item>
          </Col>
        </Row>
      )}
    </Form>
  );
};

export default AttachmentTypeForm;
